export default __webpack_public_path__ + "static/media/yes.0494bb58.svg";